import { OmniAccordionViewDataModel } from './../../../models/omniAccordionViewDataModel';
import {takeUntil} from 'rxjs/operators';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild, AfterContentChecked, Input } from '@angular/core';
import { AuthenticationService } from "@omni/services/authentication.service";
import { IonList, LoadingController, NavController, PopoverController, ModalController } from "@ionic/angular";
import { FooterService } from "@omni/services/footer/footer.service";
import { DeviceService } from "@omni/services/device/device.service";
import { ComponentViewMode, UIService } from "@omni/services/ui/ui.service";
import { ContactOfflineService } from "@omni/services/contact/contact.service";
import { ContactConsent } from "../../../classes/consent/contact-consent.class";
import { ConsentService } from "@omni/services/consent/consent.service";
import { Product } from "../../../classes/consent/product.class";
import { Channel, ChannelType, ChannelValue } from "../../../classes/consent/channel.class";
import { BrandOfflineService } from "@omni/services/brand/brand.service";
import { PopoverComponent } from "../../popover/popover";
import { ConsentTerm } from "../../../classes/consent/consent-term.class";
import { Subject, BehaviorSubject} from "rxjs";
import { ActiveConsentsFilter } from "../../../pipes/active-consents-filter.pipe";
import { NavigationService, PageName } from "@omni/services/navigation/navigation.service";
import { TranslateService } from '@ngx-translate/core';
import { AccordionViewDataModel } from '../../../models/accordionDataModel';
import { MainCardViewDataModel } from '../../../models/MainCardViewDataModel';
import { IndFormFieldViewDataModel } from '../../../models/indFormFieldDataModel';
import { DateTimeFormatsService } from '@omni/services/date-time-formats/date-time-formats.service';
import { IndSectionHeaderViewDataModel } from '../../../models/indSectionHeaderDataModel';
import { DatePipe } from '@angular/common';
import { IndAlertMsgComponent } from '@omni/components/shared/ind-alert-msg/ind-alert-msg';
import { ConsentActivity, ConsentActivityType } from '@omni/classes/consent/consent-activity.class';
import { IndFilterMenuModalComponent, IndFilterMenuModalDataModel } from '@omni/components/shared/ind-filter-menu-modal/ind-filter-menu-modal';
import { IndDropdownListDetailModel } from '@omni/models/indDropdownListModel';
import { IndDropdownListComponent } from '@omni/components/shared/ind-dropdown-list/ind-dropdown-list';
import { TrackingEventNames, TrackService } from '@omni/services/logging/tracking.service';
import { FeatureActionsMap, IoConfigurationFeatureCodes } from '@omni/classes/authentication/user.class';
import { EntityNameForTranslation, LocalizationService } from '@omni/services/localization/localization.service';
import { cloneDeep, groupBy, isEmpty, uniqBy } from 'lodash-es';
import { NotificationService, ToastStyle } from '@omni/services/notification/notification.service';

/**
 * Generated class for the ContactConsentComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
// OnPush deferred — reads authenticationService, footerService, uiService, trackingService directly in template
@Component({
  selector: 'contact-consent',
  templateUrl: 'contact-consent.html',
  styleUrls:['contact-consent.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ContactConsentComponent {
  trackById(index: number, item: any) { return item?.id || item?.ID || index; }


  private selectedContactConsents: ContactConsent;
  private _consentsFilterPopover;
  public activeConsentsSubject = new BehaviorSubject<ConsentTerm[]>([]);
  public activeConsentsObs$ = this.activeConsentsSubject.asObservable();
  public activeConsentsModel: OmniAccordionViewDataModel[] = [];
  public pendingSyncConsentsSubject = new BehaviorSubject<ConsentTerm[]>([]);
  public pendingSyncConsentsObs$ = this.pendingSyncConsentsSubject.asObservable();
  public pendingSyncConsentsModel:OmniAccordionViewDataModel[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();
  private consentsFilter: ActiveConsentsFilter;
  isFilterApplied: boolean = false;
  public contactConsentPendingHeader: IndSectionHeaderViewDataModel;
  @ViewChild(IonList, { read: ElementRef, static: false }) list: ElementRef;
  public contactConsentActiveHeader: IndSectionHeaderViewDataModel;
  public filteredConsentActiveHeader: IndSectionHeaderViewDataModel;
  public activeConsentsGrid: any[] = [];
  public pendingSyncConsentsGrid: any[] = [];
  // New aggregated view models
  public newActiveConsentsGrid: any[] = [];
  public newPendingSyncConsentsGrid: any[] = [];
  private popover: HTMLIonPopoverElement;
  public isOptOutFiltered: boolean = false;
  public activeConsentFilterFormView: IndFilterMenuModalDataModel[] = [];
  public selectedFilters: any= [];
  private filterdConsentActivity: any[] = [];
  public hasFilteredConsentActivity = false;
  public isOptOutEnabled: boolean = false;
  public aggregatedTopics: Array<{id: string, name: string}> = [];
  @Input() readOnly: boolean;
  private deletedConsentIDs: String = "";


  constructor(
    public authenticationService: AuthenticationService,
    public navCtrl: NavController,
    public footerService: FooterService,
    public device: DeviceService,
    public uiService: UIService,
    private contactService: ContactOfflineService,
    private consentService: ConsentService,
    private productService: BrandOfflineService,
    private popoverCtrl: PopoverController,
    private navService: NavigationService,
    private _cd: ChangeDetectorRef,
    public translate: TranslateService,
    private dateTimeFormatService: DateTimeFormatsService,
    private datePipe: DatePipe,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public trackingService: TrackService,
    private localisationService: LocalizationService,
    private notificationService: NotificationService,
  ) {
    this.consentsFilter = new ActiveConsentsFilter(this.consentService);
  }

   ngOnInit() {
    this._initSectionHeader();
    if (this.contactService.contactInformation) {
      this.consentService.loadConsentTermsFromDB();
      this.consentService.allActiveConsentSubject.pipe(takeUntil(this.destroy$)).subscribe((consents: ContactConsent[]) => {
        if (!isEmpty(consents)) this.initializeActiveConsents(consents);
      });
    }
  }

  private initializeActiveConsents(consents) {
    this._cd.markForCheck();

    if (this.contactService.contactInformation) {
      this.selectedContactConsents = consents.find((consent: ContactConsent) =>
        consent.indskr_contactid.toString() === this.contactService.contactInformation.ID.toString()
      );
    }

    this.initializeDeletedActiveConsents();
    this.init();
    this._cd.markForCheck();
    this._cd.markForCheck();
  }

  ngOnDestroy() {
    this.consentService.clearFilters();
    this.destroy$.next(true);
  }


  private initializeDeletedActiveConsents() {
    if (isEmpty(this.consentService.allDeletedActiveConsents)) {
       this.consentService.getAllDeletedActiveConsentsFromDB();
    }
    if (!isEmpty(this.consentService.allDeletedActiveConsents)){
      const mappedDeletedConsentIDs = this.consentService.allDeletedActiveConsents.map(deletedActiveConsent => deletedActiveConsent['indskr_activeConsent']);
      if (mappedDeletedConsentIDs && !isEmpty(mappedDeletedConsentIDs)){
        this.deletedConsentIDs = this.consentService.allDeletedActiveConsents.map(deletedActiveConsent => deletedActiveConsent['indskr_activeConsent']).join(',') 
      }
    }
  }


  init() {
    this.isOptOutEnabled = !this.readOnly && this.contactService.contactPageMode !== ComponentViewMode.READONLY && !this.contactService.isOneKeySearching;
    this._resetOptOutFilter();

    if (this.selectedContactConsents && this.selectedContactConsents.activeConsents) {

      // Split deletedConsentIDs string into array for comparison
      const deletedConsentIDsArray = this.deletedConsentIDs ? this.deletedConsentIDs.split(',').map(id => id.trim()) : [];
      let hasChanges = false; // Track if any changes were made
      
      // Iterate backwards to safely remove items
      for (let i = this.selectedContactConsents.activeConsents.length - 1; i >= 0; i--) {
        const activeConsent = this.selectedContactConsents.activeConsents[i];
        
        // Filter consentActivity array if it exists
        if (activeConsent.consentActivity && Array.isArray(activeConsent.consentActivity)) {
          const originalLength = activeConsent.consentActivity.length;
          activeConsent.consentActivity = activeConsent.consentActivity.filter(activity => {
            // Keep the activity if it doesn't have indskr_consentid or if it's not in the deleted list
            return !activity.indskr_consentid || !deletedConsentIDsArray.includes(activity.indskr_consentid.toString());
          });

          // Check if any consentActivity was removed
          if (activeConsent.consentActivity.length < originalLength) {
            hasChanges = true;
          }

          // If consentActivity array is now empty, remove the entire activeConsent
          if (activeConsent.consentActivity.length === 0) {
            this.selectedContactConsents.activeConsents.splice(i, 1);
            hasChanges = true; // Track that an activeConsent was removed
          }
        }
      }
      
      // Save the updated consents if any changes were made
      if (hasChanges) {
        this.consentService.saveConsentTodisk(this.selectedContactConsents);
      }
      
      

      const activeConsents = this.selectedContactConsents.activeConsents.filter(consent => !consent.isOfflineSaved);
      const pendingSyncConsents = this.selectedContactConsents.activeConsents.filter(consent => consent.isOfflineSaved);

      this.consentService.showAllConsentsFilter$.pipe(
        takeUntil(this.destroy$))
        .subscribe(value => {
          this._cd.markForCheck();
          this.activeConsentsSubject.next(this.consentsFilter.transform(activeConsents));
          this.pendingSyncConsentsSubject.next(this.consentsFilter.transform(pendingSyncConsents));
          this.initNewConsentsViewModel(this.consentsFilter.transform(activeConsents), this.consentsFilter.transform(pendingSyncConsents));
          this._initFilterFormViews();
          this._cd.markForCheck();
          this._cd.markForCheck();
        });
    } else {
      this.newActiveConsentsGrid = [];
      this.activeConsentsSubject.next([]);
    }
    this.footerService.updateButtons([], true);
    this._initSectionHeader();
  }


  private _filterDeletedConsents() {
    this.selectedContactConsents.activeConsents.findIndex(activeConsent => {

      if (this.authenticationService.user.isProductConsent) {

        if (activeConsent.products && !isEmpty(activeConsent.products)) {
          activeConsent.products = activeConsent.products.filter(product => !this.deletedConsentIDs.includes(product.indskr_consentId));
        }
      }

      if (activeConsent.channels && !isEmpty(activeConsent.channels)) {

        activeConsent.channels.forEach(channel => {
          if (!isEmpty(channel?.values)) {
            const index = activeConsent.channels.findIndex(tempChannel => channel.indskr_consenttypeid == tempChannel.indskr_consenttypeid);
            channel.values = channel.values.filter(
              channelValue => !this.deletedConsentIDs.includes(channelValue.indskr_consentId)
            );
            activeConsent.channels[index] = channel;
          }
        });
      }
    });

    this.consentService.saveConsentTodisk(this.selectedContactConsents);
  }

  get pendingSyncConsents(): ConsentTerm[] {
    return this.pendingSyncConsentsSubject.getValue();
  }

  get activeConsents(): ConsentTerm[] {
    return this.activeConsentsSubject.getValue();
  }

  ngAfterViewInit(){
    setTimeout(() => {
      this.uiService.scrollListToView(this.list);
    }, 200);
  }

  private _initFilterFormViews() {
    this.activeConsentFilterFormView = [];
    if(this.activeConsents && this.activeConsents.length !== 0) {
      this.activeConsents.forEach(consent => {
        //consent term
        let idx = this.activeConsentFilterFormView.findIndex((view) => view.id == 'consent-term');
        let terms = {
          group: this.translate.instant('CONTACT_CONSENT_TERMS'),
          id: consent['indskr_consenttermsid'].toString(),
          displayName: consent['indskr_consentTermName'].toString(),
          isSelected: false,
        }
        if(idx>-1) {
          let optionIdx = this.activeConsentFilterFormView[idx].options.findIndex((opt) => opt.id == consent['indskr_consenttermsid'].toString());
          if(optionIdx<0) this.activeConsentFilterFormView[idx].options.push(terms);
        } else {
          let consentTermView = {
            id : 'consent-term',
            displayName: this.translate.instant('CONTACT_CONSENT_TERMS'),
            isMultiSelect: true,
            options: []
          }
          consentTermView.options.push(terms);
          this.activeConsentFilterFormView.push(consentTermView);
        }
        //product
        if(!isEmpty(consent.products) && this.authenticationService.user.isProductConsent) {
          consent.products?.forEach((product) => {
            let option = {
              group: this.translate.instant('PRODUCTS'),
              id: product['indskr_productid'].toString(),
              displayName: product['indskr_productname'].toString(),
              isSelected: false,
            };
            let idx = this.activeConsentFilterFormView.findIndex((view) => view.id == 'Product');
            if(idx>-1) {
              let optionIdx = this.activeConsentFilterFormView[idx].options.findIndex((opt) => opt.id == product['indskr_productid']);
              if(optionIdx<0) this.activeConsentFilterFormView[idx].options.push(option);
            } else {
              let productView = {
                id : 'Product',
                displayName: this.translate.instant('PRODUCTS'),
                isMultiSelect: true,
                options: []
              }
              productView.options.push(option);
              this.activeConsentFilterFormView.push(productView);
            }
          })
        }
        //channel
        consent.channels?.forEach((channel) => {
          let options = [];
          if(!isEmpty(channel.values)) {
            channel.values.forEach((value) => {
              let option = {
                group: `${this.localisationService.getTranslatedString(channel['indskr_consentType']?.toString(), EntityNameForTranslation.ChannelFilter)}`,
                id: `${channel['indskr_consentType'].toString()}_${value['value'].toString()}`,
                displayName: this.localisationService.getTranslatedString(value['value'].toString()),
                isSelected: false,
              }
              options.push(option);
            })
            options = uniqBy(options, 'displayName');
            let idx = this.activeConsentFilterFormView.findIndex((view) => view.id == channel['indskr_consenttypeid'].toString());
            if(idx>-1) {
              let temp = cloneDeep(this.activeConsentFilterFormView[idx].options);
              let channelOptions = uniqBy(temp.concat(options), 'displayName');
              this.activeConsentFilterFormView[idx].options = channelOptions;
            } else {
              this.activeConsentFilterFormView.push({
                id : channel['indskr_consenttypeid'].toString(),
                displayName: this.localisationService.getTranslatedString(channel['indskr_consentType']?.toString(), EntityNameForTranslation.ChannelFilter),
                isMultiSelect: true,
                options: options
              })
            }
          }
        })
      })
      
      //topics
      if(this.aggregatedTopics && this.aggregatedTopics.length > 0 && 
        (this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONSENT_GA_FETCHRTM) as boolean)) {
        let topicOptions = this.aggregatedTopics.map(topic => ({
          group: this.translate.instant('TOPICS'),
          id: topic.id,
          displayName:  this.localisationService.getTranslatedString(
            topic.name, 
            EntityNameForTranslation.Topic
          ),
          isSelected: false,
        }));
        
        let topicView = {
          id: 'Topic',
          displayName: this.translate.instant('TOPICS'),
          isMultiSelect: true,
          options: topicOptions
        };
        this.activeConsentFilterFormView.push(topicView);
      }
    }
  }


  // NEW IMPLEMENTATION - Single aggregated record view
  private initNewConsentsViewModel(activeConsents: ConsentTerm[], pendingConsents: ConsentTerm[]): void {
    this.newActiveConsentsGrid = [];
    this.newPendingSyncConsentsGrid = [];

    // Populate aggregated topics from active consents
    if(activeConsents && activeConsents.length !== 0) {
      this.aggregatedTopics = this.getAggregatedTopicsFromConsents(activeConsents);
      const gridFields = this._getNewGridFieldsForConsents(activeConsents, true);
      this.newActiveConsentsGrid.push({
        id: 'all-active-consents',
        consentTermName: this.translate.instant('ALL_CONSENT_TERMS'),
        childItems: gridFields,
      });
    }

    if(pendingConsents && pendingConsents.length !== 0) {
      const gridFields = this._getNewGridFieldsForConsents(pendingConsents, false);
      this.newPendingSyncConsentsGrid.push({
        id: 'all-pending-consents',
        consentTermName: this.translate.instant('ALL_CONSENT_TERMS'),
        childItems: gridFields,
      });
    }
  }


  // NEW IMPLEMENTATION - Click handler for new aggregated view
  public handleNewConsentExpandClick(consents: ConsentTerm[], isPending: boolean, event) {
    event.stopPropagation();
    this.openNewConsentsDetailScreen(consents, isPending);
  }

  // NEW IMPLEMENTATION - Get grid fields for aggregated consents
  private _getNewGridFieldsForConsents(consents: ConsentTerm[], isActiveConsents: boolean = false): Array<any> {
    const items: Array<any> = [];
    const numOfCol = 3;

    // Products Field - aggregated from all consents (only if product consent is enabled)
    if(this.authenticationService.user.isProductConsent) {
      const products = this.getAggregatedProductsFromConsents(consents);
      if(products && products.length > 0) {
      let dropDownProducts = [];
      if(products.length > 1) {
        for(let i = 1; i < products.length; i++) {
          dropDownProducts.push({
            title: products[i]
          });
        }
      }
      items.push({
        id: 'products_field',
        label: this.translate.instant('PRODUCTS'),
        value: products[0],
        isMultipleValue: products.length > 1,
        dropDownText: `(+${products.length - 1})`,
        dropDownValue: dropDownProducts,
        allValue: products.join(', ')
      });
      }
    }

    // Channels Fields - aggregated from all consents
    const channels = this.getAggregatedChannelsFromConsents(consents);
    channels.forEach(channel => {
      // Additional safety check: skip channels with empty values (matching old implementation)
      if (!channel.values || channel.values.length === 0 || !channel.label) {
        return;
      }
      
      let dropDownChannel = [];
      if(channel.values.length > 1) {
        for(let i = 1; i < channel.values.length; i++) {
          dropDownChannel.push({
            title: channel.values[i]
          });
        }
      }
      items.push({
        id: 'channel_field_' + channel.id,
        label: channel.label,
        value: channel.values[0],
        isMultipleValue: channel.values.length > 1,
        dropDownText: `(+${channel.values.length - 1})`,
        dropDownValue: dropDownChannel,
        allValue: channel.values.join(', ')
      });
    });

    // Topics Field - aggregated from all consents
    let topics: string[] = [];
    if(isActiveConsents && this.aggregatedTopics && this.aggregatedTopics.length > 0) {
      // Use pre-computed aggregatedTopics for active consents
      topics = this.aggregatedTopics.map(t => t.name);
    } else {
      // For pending consents, compute topics from consents
      const topicObjects = this.getAggregatedTopicsFromConsents(consents, !isActiveConsents);
      topics = topicObjects.map(t => t.name);
    }
    
    if(topics && topics.length > 0 && (this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONSENT_GA_FETCHRTM) as boolean)) {
      let dropDownTopics = [];
      if(topics.length > 1) {
        for(let i = 1; i < topics.length; i++) {
          dropDownTopics.push({
            title: topics[i]
          });
        }
      }
      items.push({
        id: 'topics_field',
        label: this.translate.instant('TOPICS'),
        value: topics[0],
        isMultipleValue: topics.length > 1,
        dropDownText: `(+${topics.length - 1})`,
        dropDownValue: dropDownTopics,
        allValue: topics.join(', ')
      });
    }

    // Arrange items in rows of 3 columns
    const numOfRow = Math.ceil(items.length / numOfCol);
    const childItems = [];
    for(let i = 0; i < numOfRow; i++) {
      childItems[i] = [];
      for(let j = 0; j < numOfCol; j++) {
        if(!isEmpty(items[i * numOfCol + j])) {
          childItems[i].push(items[i * numOfCol + j]);
        }
      }
    }

    return childItems;
  }

  // Get aggregated products from consent products
  private getAggregatedProductsFromConsents(consents: ConsentTerm[]): string[] {
    const productSet = new Set<string>();
    
    if (this.authenticationService.user.isProductConsent) {
      consents.forEach(consent => {
        if (!isEmpty(consent.products)) {
          consent.products.forEach(product => {
            if (product.indskr_productname) {
              productSet.add(product.indskr_productname);
            }
          });
        }
      });
    }

    return Array.from(productSet).sort();
  }

  // Get aggregated channels from consent channels
  private getAggregatedChannelsFromConsents(consents: ConsentTerm[]): Array<{id: string, label: string, values: string[]}> {
    const channelMap = new Map<string, {id: string, label: string, values: Set<string>}>();
    
    consents.forEach(consent => {
      if (!isEmpty(consent.channels)) {
        consent.channels.forEach(channel => {
          const channelId = channel.indskr_consenttypeid ? channel.indskr_consenttypeid.toString() : '';
          if (channelId && !channelMap.has(channelId)) {
            channelMap.set(channelId, {
              id: channelId,
              label: this.displayChannelLabels(channel.indskr_consentType ? channel.indskr_consentType.toString() : ''),
              values: new Set<string>()
            });
          }
          
          // Add channel values from channel.values array
          if (channelId && !isEmpty(channel.values)) {
            channel.values.forEach(channelValue => {
              if (channelValue.value) {
                channelMap.get(channelId).values.add(channelValue.value.toString());
              }
            });
          }
        });
      }
    });

    // Convert to array format and filter out channels with empty values
    const channels: Array<{id: string, label: string, values: string[]}> = [];
    channelMap.forEach((channel, id) => {
      const valuesArray = Array.from(channel.values).sort();
      // Only add channel if it has values and a valid label (matching old implementation behavior)
      if (valuesArray.length > 0 && channel.label) {
        channels.push({
          id: channel.id,
          label: channel.label,
          values: valuesArray
        });
      }
    });

    return channels;
  }

  // Get aggregated topics from consent activities
  private getAggregatedTopicsFromConsents(consents: ConsentTerm[], isPendingConsents: boolean = false): Array<{id: string, name: string}> {
    const topicMap = new Map<string, {id: string, name: string}>();
    
    // Extract unique topics from each consent's consentActivity array
    consents.forEach(consent => {
      if(isPendingConsents && consent.topics && !isEmpty(consent.topics)){
        consent.topics.forEach(topic => {
          const topicId = topic.indskr_topic || topic["topic"];
          const rawTopicName = topic.indskr_topicname || topic["topicName"];
          if (topicId && rawTopicName) {
            const topicName = this.localisationService.getTranslatedString(
              rawTopicName, 
              EntityNameForTranslation.Topic
            );
            if (!topicMap.has(topicId.toString())) {
              topicMap.set(topicId.toString(), {
                id: topicId.toString(),
                name: topicName
              });
            }
          }
        });
      }
      else if (consent.consentActivity && !isEmpty(consent.consentActivity)) {
        consent.consentActivity.forEach(activity => {
          // Get topic ID and name
          const topicId = activity.indskr_topic || activity["topic"];
          const rawTopicName = activity.indskr_topic_Formatted || activity["topicName"];
          
          if (topicId && rawTopicName) {
            const topicName = this.localisationService.getTranslatedString(
              rawTopicName, 
              EntityNameForTranslation.Topic
            );
            // Use topicId as key to avoid duplicates
            if (!topicMap.has(topicId.toString())) {
              topicMap.set(topicId.toString(), {
                id: topicId.toString(),
                name: topicName
              });
            }
          }
        });
      }
    });

    return Array.from(topicMap.values()).sort((a, b) => a.name.localeCompare(b.name));
  }

  // Open new consent details screen
  public openNewConsentsDetailScreen(consents: ConsentTerm[], isPending: boolean) {
    const contactId = this.contactService.contactInformation ? this.contactService.contactInformation.ID : null;
    this.navService.pushChildNavPageWithPageTracking(
      PageName.ConsentTermDetailsComponent,
      PageName.ConsentTermDetailsComponent,
      PageName.ContactPageComponent,
      { consents: consents, isPending: isPending, contactId: contactId }
    );
  }

  public async expandItemValues(item, event) {
    event.stopPropagation();
    const dropdownListDetail: IndDropdownListDetailModel = {
      id: 'active-consent-grid-drop-down',
      data: item.dropDownValue,
      isReadOnly: true
    };
    let gridDropDown = await this.popoverCtrl.create({component: IndDropdownListComponent,
                                                     componentProps: {viewData:dropdownListDetail},
                                                     cssClass:'dropdown-list-view',
                                                     event: event});
    gridDropDown.present();
    gridDropDown.onDidDismiss().then(async (data) => {

    });
  }

  private _getChildFieldsForConsentModel(consent: ConsentTerm): Array<any> {
    const items: Array<any> = [];
    //Captured On Field
    if(consent.createdon){
      items.push({
        id:'captured_on_field',
        label: this.translate.instant('CONTACT_CAPTURED_ON'),
        value: this.datePipe.transform(consent.createdon, this.dateTimeFormatService.date, undefined, this.translate.currentLang),
      });
    }

    //Expires On Field
    if(consent.indskr_untildate){
      items.push({
        id:'expired_on_field',
        label: this.translate.instant('EXPIRES_ON'),
        value: this.datePipe.transform(consent.indskr_untildate, this.dateTimeFormatService.date, undefined, this.translate.currentLang),
      });
    }

    //Products Field
    if(consent.products && this.authenticationService.user.isProductConsent){
      items.push({
        id:'products_field',
        label: this.translate.instant('PRODUCTS'),
        value: this.displayMedications(consent.products),
      });
    }

    //Channels Field
    if(consent.channels){
      consent.channels.forEach(channel=>{
        const label = this.displayChannelLabels(channel.indskr_consentType.toString());
        const text = this.displayChannelValues(channel.indskr_consentType.toString(), channel.values);
        if(label && text){
          items.push({
            id:'channel_field'+channel.indskr_consenttypeid,
            label: label,
            value: text,
          });
        }
      });
    }

    //Signature Field
    items.push({
      id:'signature_field',
      label: this.translate.instant('SIGNATURE'),
      value: (consent.indskr_signature)?this.translate.instant('YES'):this.translate.instant('NO'),
    });

    return items;
  }

  displayMedications(products: Product[]) {
    let productNames: string = "";
    if (products && products.length) {
      productNames = products
      .map(p => p.indskr_productname)
      .filter(name => name !='' && name != undefined)
      .join(', ');
    }
    return productNames;
  }

  displayChannels(channels: Channel[]) {
    try {
      channels = channels.sort((a, b) => {
        return (a.indskr_consentType.toLowerCase() > b.indskr_consentType.toLowerCase()) ? 1 : -1;
      });
    } catch (error) {
    }
    let channelNames: string = "";
    if (channels && channels.length) {
      channelNames = channels
      .map(c => this.displayChannelLabels(c.indskr_consentType))
      .filter(name => name !='' && name != undefined)
      .join(', ');
    }
    return channelNames;
  }

  displayChannelLabels(label: string) {
    let displayName: string = "";
    let translateddisplayName: string = "";
    switch (label) {
      case ChannelType.EMAIL.toString():
        displayName = ChannelType.EMAIL_ADDRESS.toString();
        break;
      case ChannelType.VISIT.toString():
        displayName = ChannelType.VISIT.toString();
        break;
      case ChannelType.PHONE.toString():
        displayName = ChannelType.PHONE_NUMBER.toString();
        break;
      default:
        displayName = label;
    }
    switch (displayName) {
      case 'Email':
        translateddisplayName = this.translate.instant('EMAIL');
        break;
      case 'Address':
        translateddisplayName = this.translate.instant('ADDRESS');
        break;
      case 'Phone':
        translateddisplayName = this.translate.instant('PHONE');
        break;
      case 'SMS':
        translateddisplayName = this.translate.instant('SMS');
        break;
      case 'Visit':
        translateddisplayName = this.translate.instant('VISIT');
        break;
      case 'WhatsApp':
        translateddisplayName = this.translate.instant('WHATSAPP');
        break;
      case 'Facebook':
        translateddisplayName = this.translate.instant('FACEBOOK');
        break;
      case 'Fax':
        translateddisplayName = this.translate.instant('FAX');
        break;
      default:
        translateddisplayName = displayName;
        break;
    }

    return translateddisplayName;
  }

  displayChannelValues(type: string, values: ChannelValue[]) {
    let channelValues: string = "";
    if (!isEmpty(values)) {
        channelValues = Array.prototype.map.call(values, c => c.value).join(', ');
    }
    return channelValues;
  }

  async openActiveConsentsFilter(event) {
    this.consentService.isProductFilterExpanded = true;
    this.consentService.isChannelFilterExpanded = true;
    this.isFilterApplied = true;
    this._consentsFilterPopover = await this.popoverCtrl.create({
      component:PopoverComponent,
      componentProps:{ field: "consentFilter" },
      cssClass: "consents-filter-popover",
      event: event}
    );
    this._consentsFilterPopover.present();
    this._consentsFilterPopover.onDidDismiss().then(() => {
      this._consentsFilterPopover = null;
      this._initSectionHeader();
    });
  }

  public getFilterText(): string {
    let str: string = 'All Consents';
    this.isFilterApplied = false;
    if (!this.productService.brands) return;
    if (this.consentService.consentProductFilter$) {
      this.isFilterApplied = true;
      if (str !== 'All Consents') {
        str += ', ' + this.consentService.consentProductFilter$.name;
      } else {
        str = this.consentService.consentProductFilter$.name;
      }
    }
    if (this.consentService.consentChannelFilter$) {
      this.isFilterApplied = true;
      if (str !== 'All Consents') {
        str += ', ' + this.consentService.displayChannelLabels(this.consentService.consentChannelFilter$.indskr_consentType.toString());
      } else {
        str = this.consentService.displayChannelLabels(this.consentService.consentChannelFilter$.indskr_consentType.toString());
      }
    }

    switch (str) {
      case 'All Consents':
        str = this.translate.instant('ALL_ACTIVE_CONSENTS');
        break;
      default:
        str = this.localisationService.getTranslatedString(str);
        break;
    }
    return str;
  }

  openConsentDetails(term: ConsentTerm) {
    if (this.contactService.accessedContactListFrom === PageName.AccountDetailsComponent && this.contactService.contactPageMode === ComponentViewMode.READONLY) return;
    const allConsentTerms: ConsentTerm[] = this.consentService.allConsentTermsSubject.getValue();
    if (allConsentTerms && allConsentTerms.length > 0) {
      const termId = term.indskr_consenttermsid || '';
      const idx = allConsentTerms.findIndex(t=>t.indskr_consenttermsid == termId);
      if (idx > -1) {
        term.indskr_body = allConsentTerms[idx].indskr_body ? allConsentTerms[idx].indskr_body : "";
        if (allConsentTerms[idx]?.indskr_agreementmessage) {
          term.indskr_agreementmessage = allConsentTerms[idx].indskr_agreementmessage;
        }
        if (allConsentTerms[idx]?.indskr_confirmationmessage) {
          term.indskr_confirmationmessage = allConsentTerms[idx].indskr_confirmationmessage;
        }
      }
    }
    this.consentService.selectedConsentTerm.next(term);
    this.consentService.consentTab = "";
    this.navService.pushWithPageTracking(PageName.ConsentDetailsComponent, PageName.ConsentDetailsComponent);
  }

  private _initSectionHeader() {
    this.contactConsentPendingHeader = {
      id: 'contact-consent-pending-header',
      title: this.translate.instant("CONTACT_PENDING_SYNC_CAP"),
      controls: [],
    };
    this.contactConsentActiveHeader = {
      id: 'contact-consent-active-header',
      title: this.translate.instant("ALL_ACTIVE_CONSENTS"),
      controls: [{
        id: 'opt-out-from-all',
        text: `${this.translate.instant('OPT_OUT_FROM_ALL')}`,
        isVisible: this.isOptOutEnabled && this.activeConsents.length > 0,
        isDisabled: false,
      },{
        id: 'active-consent-filter',
        isDisabled: false,
        isVisible: this.isOptOutEnabled && this.activeConsents.length > 0,
        icon: 'assets/imgs/header_filter.svg',
        iconSrcClass: 'filter-funnel-icon'
      }],
      doNotModifyTitleCase: true
    }
    this.filteredConsentActiveHeader = {
      id: 'filtered-consent-active-header',
      title: `${this.translate.instant("RESULTS_SMALL")}`, //(${this.filteredActiveConsentsGrid.length})
      controls: [{
        id: 'clear-results',
        text: `${this.translate.instant('CLEAR')} ${this.translate.instant('RESULTS_SMALL')}`,
        isDisabled: !this.isOptOutFiltered,
      },{
        id: 'active-consent-filter',
        isDisabled: false,
        icon: 'assets/imgs/header_filter.svg',
        iconSrcClass: 'filter-funnel-icon'
      }],
      doNotModifyTitleCase: true
    }
  }

  onSectionHeaderControlClick(id:string) {
    if (id === 'opt-out-from-all') {
      this.optOutFromAllConsent(id);
    } else if (id === 'active-consent-filter') {
      this._openActiveConsentsFilter();
    } else if (id === 'clear-results') {
      this._clearFilterResults();
    }
  }

  displayChannelLabels1(label: string) {
    let translateddisplayName: string = "";
   switch (label) {
      case 'Email':
        translateddisplayName = this.translate.instant('EMAIL');
        break;
      case 'Address':
        translateddisplayName = this.translate.instant('ADDRESS');
        break;
      case 'Phone':
        translateddisplayName = this.translate.instant('PHONE');
        break;
      case 'SMS':
        translateddisplayName = this.translate.instant('SMS');
        break;
      case 'Visit':
        translateddisplayName = this.translate.instant('VISIT');
        break;
      case 'WhatsApp':
        translateddisplayName = this.translate.instant('WHATSAPP');
        break;
      case 'Facebook':
        translateddisplayName = this.translate.instant('FACEBOOK');
        break;
      case 'Fax':
        translateddisplayName = this.translate.instant('FAX');
        break;
     case 'Campaign':
       translateddisplayName = this.translate.instant('CAMPAIGN');
       break;
      default:
        translateddisplayName = label;
        break;
    }

    return translateddisplayName;
  }

  public async openMoreOptions(id, event, eventName) {
    event.stopPropagation();
    let data  = [{
      id: 'timeline',
      title: this.translate.instant('TIMELINE')
    }
    ]
    const dropdownListDetail: IndDropdownListDetailModel = {
      id: 'active-consent-more-option-drop-down',
      data: data,
      isReadOnly: false,
      isMultipleSelectionEnabled: false
    };
    let gridDropDown = await this.popoverCtrl.create({component: IndDropdownListComponent,
                                                     componentProps: {viewData:dropdownListDetail},
                                                     cssClass:'dropdown-list-view',
                                                     event: event});
    gridDropDown.present();
    gridDropDown.onDidDismiss().then(async (data) => {
      if (data && data.data && data.data.selectedItems) {
        if (data.data.selectedItems[0].id == 'timeline') {
          if( this.authenticationService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI,true)){
            this.uiService.timelineRefreshRequired = true;
            this.contactService.isOpenedConsentTimelineFromConsentCard = true;
            this.navService.pushChildNavPageWithPageTracking(PageName.ContactTimelinePageComponent,PageName.ContactTimelinePageComponent,PageName.ContactPageComponent);
          }else{
            this.uiService.contactDetailsSegment = 'timeline';
            const insightsEventName = this.contactService.contactPageMode === ComponentViewMode.ADDNEW ? 'Contact Timeline  via Meeting' : 'ContactTimeline'
            this.trackingService.tracking(insightsEventName, TrackingEventNames.CONTACTS)
          }
        }
      }
    });
  }

  public async optOutFromConsent(event, consent?) {
    event.stopPropagation();
    let message;
    if(this.isOptOutFiltered) {
      let channelText = Array.prototype.map.call(this.selectedFilters, a => `${a.label} <b>"${a.value}"</b>`).join(", ");
      if(channelText.includes(this.translate.instant('CONTACT_CONSENT_TERMS'))) channelText = '';
      message = this.translate.instant('OPT_OUT_EACH_TERM', { channel: channelText, termName: consent.consentTermName });
    } else {
      message = this.translate.instant('OPT_OUT_EACH_TERM', { channel: '', termName: consent.consentTermName });
    }
    let popoverOptions = {
      header: this.translate.instant('OPT_OUT'),
      message: message,
      confirmText: this.translate.instant('CONFIRM'),
    }
    this.popover = await this.popoverCtrl.create({
      component: IndAlertMsgComponent,
      componentProps: popoverOptions,
      cssClass: this.device.isNativeApp ? 'native-ind-alert-msg' : 'ind-alert-msg',
      backdropDismiss: true,
    });
    this.popover.present();

    await this.popover.onDidDismiss().then(async (res:any) => {
      if(res.data && res.data.role && res.data.role == 'ok') {
        let loader = await this.loadingCtrl.create();
        let tempConActivities = [];
        if(this.isOptOutFiltered) {
          this.filterdConsentActivity[consent.id].forEach((activity) => {
            let optOut = this._prepareOptOutPayload(activity);
            optOut['indskr_ConsentTerms@odata.bind'] = consent.id;
            optOut['indskr_consentTermName'] = consent.consentTermName;
            tempConActivities.push(optOut);
          })
        } else {
          let foundConsent = this.activeConsents.find(con => con.indskr_consenttermsid == consent.id);
          foundConsent.consentActivity.filter(ca => ca.indskr_consentactivitytype == ConsentActivityType.OPT_IN).forEach((act) => {
            let optOut = this._prepareOptOutPayload(act);
            optOut['indskr_ConsentTerms@odata.bind'] = consent.id;
            optOut['indskr_consentTermName'] = consent.consentTermName;
            tempConActivities.push(optOut);
          })
        }
        await loader.present();
        this.consentService.createOptOutConsentActivity(tempConActivities).then(async () => {
          await loader.dismiss();
          this._clearFilterResults();
          this._initSectionHeader();
          }, async error => {
          await loader.dismiss();
        })
      }
    })
  }

  public async optOutFromAllConsent(id) {
    if (this.isOptOutFiltered && !this.hasFilteredConsentActivity) return;
    if (this._notifyIfOffline()) return;
    let message;
    if(this.isOptOutFiltered) {
      let channelText = Array.prototype.map.call(this.selectedFilters, a => `${a.label} <b>"${a.value}"</b>`).join(", ");
      message = this.translate.instant('OPT_OUT_ALL_TERMS', {channel: channelText});
    } else {
      message = this.translate.instant('OPT_OUT_ALL_TERMS', { channel: '' });
    }
    let popoverOptions = {
      header: this.translate.instant('OPT_OUT'),
      message: message,
      confirmText: this.translate.instant('CONFIRM'),
    }
    this.popover = await this.popoverCtrl.create({
      component: IndAlertMsgComponent,
      componentProps: popoverOptions,
      cssClass: this.device.isNativeApp ? 'native-ind-alert-msg' : 'ind-alert-msg',
      backdropDismiss: true,
    });
    this.popover.present();
    await this.popover.onDidDismiss().then(async (res: any) => {
      if(res.data && res.data.role && res.data.role == 'ok') {
        let loader = await this.loadingCtrl.create();
        let tempConActivities = [];
        this.activeConsents.forEach((consent) => {
          if(this.isOptOutFiltered) {
            this.filterdConsentActivity[consent.indskr_consenttermsid.toString()]?.forEach((filteredAct) => {
              let toBeOptedOutAct = consent.consentActivity.find(consentAct => consentAct.indskr_consentactivityid == filteredAct.indskr_consentactivityid);
              if(!isEmpty(toBeOptedOutAct)) {
                let filteredOptOut = this._prepareOptOutPayload(toBeOptedOutAct, consent);
                filteredOptOut['indskr_ConsentTerms@odata.bind'] = consent.indskr_consenttermsid;
                filteredOptOut['indskr_consentTermName'] = consent.indskr_consentTermName;
                tempConActivities.push(filteredOptOut);
              }
            })
          } else {
            consent.consentActivity.filter(ca => ca.indskr_consentactivitytype == ConsentActivityType.OPT_IN).forEach((act) => {
              let optOut = this._prepareOptOutPayload(act, consent);
              optOut['indskr_ConsentTerms@odata.bind'] = consent.indskr_consenttermsid;
              optOut['indskr_consentTermName'] = consent.indskr_consentTermName;
              tempConActivities.push(optOut);
            })
          }
        })
        await loader.present();
        this.consentService.createOptOutConsentActivity(tempConActivities).then(async () => {
          await loader.dismiss();
          this._clearFilterResults();
          this._initSectionHeader();
          }, async error => {
          await loader.dismiss();
        })
      }
    })
  }

  private _getPurposeAndComplianceProfileFromConsent(consent: ConsentTerm, topicId: string): { purpose: string | null, complianceProfile: string | null } {
    if (!consent || !topicId) return { purpose: null, complianceProfile: null };
    
    // Fallback: Look up from allConsentTermsSubject (which has topics populated from mappings)
    const allConsentTerms: ConsentTerm[] = this.consentService.allConsentTermsSubject.getValue();
    if (allConsentTerms && allConsentTerms.length > 0) {
      const termId = consent.indskr_consenttermsid || '';
      const consentTerm = allConsentTerms.find(t => {
        return t.indskr_consenttermsid === termId.toString();
      });
      if (consentTerm && Array.isArray(consentTerm.topics) && consentTerm.topics.length > 0) {
        const topic = consentTerm.topics.find(t => t.indskr_topic?.toString() === topicId.toString());
        if (topic) {
          return {
            purpose: topic.indskr_purpose || null,
            complianceProfile: topic.indskr_complianceprofile || null
          };
        }
      }
    }
    return { purpose: null, complianceProfile: null };
  }

  private _prepareOptOutPayload(activity:ConsentActivity, consent?: ConsentTerm) {
    let payload = {};
    payload['indskr_Contact@odata.bind'] = this.contactService.contactInformation.ID;
    payload['indskr_type'] = 100000001;
    payload['indskr_SalesRep@odata.bind'] = this.authenticationService.user.xSystemUserID;
    payload['indskr_Position@odata.bind'] = this.authenticationService.user.xPositionID;
    payload['indskr_ConsentType@odata.bind'] = activity.indskr_consenttypeid;
    payload['indskr_consentTypeName'] = activity.indskr_consentTypeName;
    payload['indskr_Product@odata.bind'] = activity.indskr_product;
    payload['indskr_productname'] = activity.indskr_productname;
    payload['indskr_EmailAddress@odata.bind'] = activity.indskr_emailaddress;
    payload['indskr_addressname'] = activity.indskr_addressname;
    payload['indskr_phone'] = activity.indskr_phone;
    payload['createdon'] = new Date().getTime();
    if (activity.indskr_topic || activity["topic"]) {
      const topicId = activity.indskr_topic || activity["topic"];
      payload['indskr_Topic@odata.bind'] = topicId;
      if (consent) {
        const { purpose, complianceProfile } = this._getPurposeAndComplianceProfileFromConsent(consent, topicId.toString());
        if (purpose) {
          payload['indskr_Purpose@odata.bind'] = purpose;
        }
        if (complianceProfile) {
          payload['indskr_ComplianceProfile@odata.bind'] = complianceProfile;
        }
      }
    }
    return payload;
  }

  private _notifyIfOffline(): boolean {
    if (!this.device.isOffline) return false;
    this.notificationService.notify(this.translate.instant('CONSENT_OPT_OUT_NEEDS_CONNECTION'), 'contactConsent', 'top', ToastStyle.DANGER, 4000, true);
    return true;
  }

  private async _openActiveConsentsFilter() {
    if (this._notifyIfOffline()) return;
    // handle selected options
    const modal = await this.modalCtrl.create({
      component: IndFilterMenuModalComponent,
      cssClass: 'filter-menu-right-modal',
      backdropDismiss: true,
      componentProps: {
        viewData: {
          from: PageName.ConsentDetailsComponent,
          data: this.activeConsentFilterFormView,
          filterTitle: this.translate.instant('OPT_OUT'),
        },
      }
    });
    await modal.present().then(() => {});
    modal.onDidDismiss().then(async(res)=>{
      //Show Result
      if(res && res.data && res.data.isDone) {
        if(!isEmpty(res.data.selectedItems)) {
          this.activeConsentFilterFormView = res.data.selectedItems;
          this.isOptOutFiltered = true;
          this.selectedFilters = Object.entries(groupBy(res.data.selectedItemsAccordion, 'value')).map(([key, value]) => {
                                    let channelValues = Array.prototype.map.call(value, c => c.label).join(', ')
                                    return {label: value[0].category, value: channelValues};
                                  });

          this._getFilteredActivities(res.data.selectedItemsAccordion);
          this._initSectionHeader();
        }
      }
    })

  }

  private _getFilteredActivities(selectedFilters) {
    this.filterdConsentActivity = [];
    this.hasFilteredConsentActivity = false;
    // Channel types are separate filter categories, but an activity has one channel, so they OR together.
    const filtersByCategory = Object.values(groupBy(selectedFilters, filter =>
      ['consent-term', 'Product', 'Topic'].includes(filter.type) ? filter.type : 'channel'));
    this.activeConsents.forEach((consent) => {
      const termId = consent.indskr_consenttermsid.toString();
      this.filterdConsentActivity[termId] = uniqBy(consent.consentActivity.filter(activity =>
        activity['indskr_consentactivitytype'] == ConsentActivityType.OPT_IN
        && filtersByCategory.every(categoryFilters => categoryFilters.some(filter => this._activityMatchesFilter(consent, activity, filter)))
      ), 'indskr_consentactivityid');
      if (this.filterdConsentActivity[termId].length) this.hasFilteredConsentActivity = true;
    })
  }

  private _activityMatchesFilter(consent: ConsentTerm, activity: ConsentActivity, filter: { type: string; id: string; label: string }): boolean {
    switch (filter.type) {
      case 'consent-term':
        return consent.indskr_consenttermsid == filter.id;
      case 'Product':
        return activity['indskr_product'] == filter.id;
      case 'Topic':
        return activity['indskr_topic'] == filter.id || activity['_indskr_topic_value'] == filter.id || activity['topic'] == filter.id;
      default:
        return activity['indskr_consenttypeid'] == filter.type
          && [activity['indskr_emailaddress'], activity['indskr_phone'], activity['indskr_faxnumber'], activity['indskr_addressname']].includes(filter.label);
    }
  }

  private _resetOptOutFilter() {
    this.isOptOutFiltered = false;
    this.selectedFilters = [];
    this.filterdConsentActivity = [];
    this.hasFilteredConsentActivity = false;
  }

  private _clearFilterResults() {
    this._resetOptOutFilter();
    this.initNewConsentsViewModel(this.activeConsents, this.pendingSyncConsents);
    this._initFilterFormViews();
  }

}
